const updateHash = (highlight) => {
  document.location.hash = `highlight-${highlight.id}`;
};

// Função para detectar e converter links em texto
const linkifyText = (text) => {
  if (!text) return text;
  
  // Regex para detectar URLs (incluindo http, https, www e domínios simples)
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
  
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // Garantir que o link tem protocolo
      let url = part;
      if (!part.startsWith('http://') && !part.startsWith('https://')) {
        url = 'https://' + part;
      }
      
      return (
        <a 
          key={index}
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#007bff',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
          onClick={(e) => e.stopPropagation()} // Evitar que o clique no link interfira com outros eventos
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

export function Sidebar({ highlights, setRemover, tipo }) {

  const getNomeCompetencia = (competencia) => {

    console.log('tipo ',tipo);

    if(competencia == 1){
      return tipo != 1 ? `Competência ${competencia}` : `Modalidade culta da língua`;
    }else if(competencia == 2){
      return tipo != 1 ? `Competência ${competencia}` : `Tipologia textual`;
    }else if(competencia == 3){
      return tipo != 1 ? `Competência ${competencia}` : `Argumentação`;
    }else if(competencia == 4){
      return tipo != 1 ? `Competência ${competencia}` : `Coesão e Estrura do período`;
    }else if(competencia == 5){
      return tipo != 1 ? `Competência ${competencia}` : `Adequação ao tema`;
    }else{
      return 'Observação';
    }
  }


  return (
    <div className="sidebar">
      <div className="description">
        <p>
          <small>Todos os pontos da correção serão mostrados abaixo</small>
        </p>
      </div>

      <ul className="sidebar__highlights">
        {highlights.map((highlight, index) => (
          <li
            key={index}
            className={`sidebar__highlight competencia_${highlight?.competencia}`}
          >
            <div>
              <strong>
              {highlight?.competencia === 0
                  ? "Salvando informação"
                  : getNomeCompetencia(highlight?.competencia)
                  }
                : {linkifyText(highlight.comment.text.replace("undefined ", ""))}
              </strong>
              {highlight.content.text ? (
                <blockquote style={{ marginTop: "0.5rem" }}>
                  {`${highlight.content.text.slice(0, 90).trim()}…`}
                </blockquote>
              ) : null}
              {highlight.content.image ? (
                <div
                  className="highlight__image"
                  style={{ marginTop: "0.5rem" }}
                >
                  <img src={highlight.content.image} alt={"Screenshot"} />
                 
                </div>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
